import buttonData from '@/data/Companies'
export const filteredButtons = {
  data: function () {
    return {
      btns: [...buttonData.COMPANIES],
      buttonData: []
    }
  },
  methods: {
    filterButtons (screenName) {
      this.btns.forEach(item => {
        const subCategories = [...item.subCategories]
        subCategories.forEach(s => {
          if (s.name.indexOf(screenName) > -1) {
            this.buttonData.push(item)
          }
        })
      })
    }
  }
}
